import produce from "immer"
import { SET_SETTINGS_ERROR } from "./constants";


export const initialState = {
    settingsError: null,
    isLoading: false
}

const settingsReducer = (state = initialState, action) => 
    produce(state, (draft) => {
        // eslint-disable-next-line default-case
        switch (action.type) {
            case SET_SETTINGS_ERROR:
                draft.settingsError = action.settingsError;
                break;
        }
    });


export default settingsReducer;
